<template>
    <div class="local-data">
        <div class="filter-criteria">
            <div class="revenue-title">团队管理</div>
        </div>
        <div class="table-data">
            <div class="table-content">
                <div class="basic-info">
                    <div class="operate-group">
                        <a-button class="add-data" type="primary" @click="addData">
                            <a-icon type="plus" />
                            新增
                        </a-button>
                        <a-button class="add-data" type="primary" @click="setMonthQuota">
                            <a-icon type="plus" />
                            设置月额度
                        </a-button>
                    </div>
                    <div class="tree-table">
                        <div class="tree">
                            <div style="color:rgba(18, 18, 18, 1);font-size:16px;padding-left:24px;margin-bottom:0px;">
                                部门树
                                <span style="display:inline-block;width:326px;height:1px"></span>
                            </div>
                            <TreeData ref="child1"></TreeData>
                        </div>
                        <div class="table-data">
                            <a-table
                                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                                :data-source="tableData"
                                :pagination="false"
                                :scroll="{ x: 'max-content' }"
                                :rowKey="record => record.id"
                            >
                                <a-table-column key="name" title="用户姓名" data-index="name" >
                                    <template slot-scope="text, record">
                                        <div>
                                        <a @click="viewRecords(record)">{{ record.name }}</a>
                                        </div>
                                    </template>
                                </a-table-column>
                                <a-table-column key="departmentName" title="部门名称" data-index="departmentName" />
                                <a-table-column key="lastLoginTime" title="最近登录时间" data-index="lastLoginTime" />
                                <a-table-column key="monthQuota" title="月额度" data-index="monthQuota" />
                                <a-table-column key="leftQuota" title="剩余月额度" data-index="leftQuota" />
                                <a-table-column key="phone" title="手机号" data-index="phone" />
                                <a-table-column key="createTime" title="创建时间" data-index="createTime" />
                                <a-table-column key="expirationTime" title="到期时间" data-index="expirationTime" />
                                <a-table-column key="statusName" title="用户状态名称" data-index="statusName" />
                                <a-table-column key="rolName" title="用户角色名称" data-index="rolName" />
                            </a-table>
                            <div class="pagination-table">
                                <a-pagination
                                    show-size-changer
                                    :total="total"
                                    :show-total="total => `共 ${total} 条     `"
                                    v-model="currentPage"
                                    @change="pageChange"
                                    @showSizeChange="onShowSizeChange"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <a-drawer
                    :title='drawerTitle'
                    placement="right"
                    :closable="true"
                    :visible="visible"
                    :destroyOnClose='true'
                    :maskClosable='true'
                    @close="onClose"
                    :width='800'
                    :mask='true'
                    :headerStyle="{ border: 'none', height: '56px', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '100'}"
                    :bodyStyle="{ background: 'rgba(240, 242, 243, 1)', height: '100%', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '10', padding: '72px 0 0' }"
                >
                    <div class="drawer-set drawer-public">
                        <div class="drawer-content">
                            <div class="drawer-body-content">
                                <a-row class="row-list">
                                    <a-col :span="12" class="col-left">
                                        <div class="title">
                                            <span>手机号：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <a-input v-if="dataObj.ifEdit==true" class="content" v-model="dataObj.phone" placeholder="请输入用户名" />
                                        <div v-if="dataObj.ifEdit==false" class="content">{{currentPersonalInfo.phone}}</div>
                                    </a-col>
                                    <a-col :span="12" class="col-right">
                                        <div class="title">
                                            <span>密码：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <div class="original-password content">初始密码为123456</div>
                                    </a-col>
                                </a-row>
                                <a-row class="row-list">
                                    <a-col :span="12" class="col-left">
                                        <div class="title">
                                            <span>姓名：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <a-input v-if="dataObj.ifEdit==true" class="content" v-model="dataObj.name" placeholder="请输入姓名" />
                                        <div v-if="dataObj.ifEdit==false" class="content">{{currentPersonalInfo.name}}</div>
                                    </a-col>
                                    <a-col :span="12" class="col-right">
                                        <div class="title">
                                            <span>部门：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <a-tree-select
                                            v-if="dataObj.ifEdit==true"
                                            v-model="dataObj.deptId"
                                            style="width: 265px;display:inline-block;"
                                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                            :tree-data="treeData"
                                            placeholder="请选择"
                                            tree-default-expand-all
                                        >
                                        </a-tree-select>
                                        <div v-if="dataObj.ifEdit==false" class="content">{{currentPersonalInfo.departmentName}}</div>
                                    </a-col>
                                </a-row>
                                <a-row class="row-list" v-if="dataObj.id!=null&&dataObj.ifEdit==true">
                                     <a-col :span="12" class="col-left">
                                        <div class="title">
                                            <span>月额度：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <div class="original-password content">{{currentPersonalInfo.monthQuota}}</div>
                                    </a-col>
                                </a-row>
                                <a-row class="row-list">
                                    <a-col :span="24" v-if="dataObj.ifEdit==true">
                                        <div class="title">
                                            <span>角色：</span>
                                        </div>
                                        <ul class="role-list">
                                            <li @click="selectRole(1)" :class="{'active':dataObj.role==1}">
                                                <div>管理员</div>
                                                <div>权限：企业数据查询、企业数据领取、数据导出、部门/员工列表查询、部门/员工管理、额度分配、个人/公司信息编辑、登录中台</div>
                                            </li>
                                            <li @click="selectRole(2)" :class="{'active':dataObj.role==2}">
                                                <div>高级员工</div>
                                                <div>权限：企业数据查询、企业数据领取、数据导出、个人信息编辑</div>
                                            </li>
                                            <li @click="selectRole(3)" :class="{'active':dataObj.role==3}">
                                                <div>普通员工</div>
                                                <div>权限：企业数据查询、企业数据领取、个人信息编辑</div>
                                            </li>
                                        </ul>
                                    </a-col>
                                    <a-col class="col-left" :span="12" v-if="dataObj.ifEdit==false">
                                        <div class="title">
                                            <span>角色：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <div class="content">{{judgeRole(currentPersonalInfo.role)}}</div>
                                    </a-col>
                                    <a-col :span="12" class="col-right" v-if="dataObj.id!=null&&dataObj.ifEdit==false">
                                        <div class="title">
                                            <span>月额度：</span>
                                        </div>
                                        <div class="clean"></div>
                                        <div class="original-password content">{{currentPersonalInfo.monthQuota}}</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                        <div class="drawer-foot">
                            <div class="btn-group">
                                <a-button type="primary" ghost @click="cancelDrawer()">取消</a-button>
                                <a-button type="primary" v-if="dataObj.ifEdit==false" @click="editDrawer()">编辑</a-button>
                                <a-button type="primary" v-if="dataObj.ifEdit==true" @click="saveDrawer()">保存</a-button>
                            </div>
                        </div>
                    </div>
                </a-drawer>
                <a-modal :centered='true' :maskClosable='false' v-model.trim="quotaModal" title="设置月额度" footer='' width='480px'>
                    <div class="edit-modal modal-public">
                        <a-divider class="divider1" type="horizontal" />
                        <div class="changed-name">输入月额度：</div>
                        <a-input v-model.trim="quotaData" placeholder="请输入月额度" />
                        <a-divider class="divider2" type="horizontal" />
                        <div class="btn-group">
                            <a-button type="primary" ghost @click="cancelQuota">取消</a-button>
                            <a-button type="primary" @click="sureQuota">确认</a-button>
                        </div>
                    </div>
                </a-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import TreeData from '../../components/TreeData'
    export default {
        name: 'MonthBill',
        components: { TreeData },
        data() {
            return {
                visible: false,
                treeData: [],
                currentPage: 1,
                pageSize: 10,
                tableData: [],
                total: 0,
                dataObj: {
                    id: null,
                    ifEdit: false,
                    phone: '',
                    name: '',
                    deptId: '',
                    monthQuota: '',
                    role: '',
                },
                currentPersonalInfo: '',
                quotaModal: false,
                quotaData: null,
                selectedRowKeys: [],
                drawerTitle: '用户-新增',
            }   
        },
        methods: {
            judgeRole(data) {
                switch (data){
                    case 1:
                        return '管理员'
                    case 2:
                        return '高级员工'
                    default :
                        return '普通员工'
                }
            },
            querySelectData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user/'+this.dataObj.id, 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.currentPersonalInfo = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryBasicData(type) {
                if(type == 'init'){
                    this.currentPage = 1
                }
                this.axios(
                    {
                    method:'get',
                    url:'/api/user/list',
                        params: {
                            current: this.currentPage,
                            size: this.pageSize,
                            departmentId: this.dataObj.deptId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                        this.total = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            viewRecords(record) {
                this.visible = true;
                this.dataObj.ifEdit = false
                this.dataObj.id = record.id
                this.drawerTitle = '用户-编辑'
                this.querySelectData()
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            queryUserTree() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user/tree', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let obj = {}
                        obj.peopleTree = response.data.data
                        obj.personSelected = []
                        this.$refs.child2.getParentData(obj)
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryTreeData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/department/tree', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.treeData = response.data.data.deptTree
                        this.$refs.child1.childMethod(this.treeData, response.data.data.allDept)
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onClose() {
                this.visible = false;
                this.dataObj = {
                    id: null,
                    phone: '',
                    name: '',
                    deptId: '',
                    monthQuota: '',
                    role: '',
                    ifEdit: false,
                }
            },
            addData() {
                this.dataObj.ifEdit = true
                this.visible = true
                this.dataObj.id = null
            },
            cancelDrawer() {
                this.visible = false
                this.dataObj = {
                    id: null,
                    phone: '',
                    name: '',
                    deptId: '',
                    monthQuota: '',
                    role: '',
                    ifEdit: false
                }
            },
            editDrawer() {
                this.dataObj.phone = this.currentPersonalInfo.phone
                this.dataObj.role = this.currentPersonalInfo.role
                this.dataObj.monthQuota = this.currentPersonalInfo.monthQuota
                this.dataObj.deptId = this.currentPersonalInfo.departmentId
                this.dataObj.name = this.currentPersonalInfo.name
                this.dataObj.ifEdit = true
            },
            saveDrawer() {
                this.axios.post('/api/user', {
                    id: this.dataObj.id,
                    phone: this.dataObj.phone,
                    departmentId: this.dataObj.deptId,
                    name: this.dataObj.name,
                    role: this.dataObj.role,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let tip = ''
                        if(this.dataObj.id==null){
                            tip = '新增成功'
                            
                        }else{
                            tip = '修改成功'
                        }
                        this.dataObj = {
                            id: null,
                            phone: '',
                            name: '',
                            deptId: '',
                            monthQuota: '',
                            role: '',
                            ifEdit: false,
                        }
                        this.queryBasicData()
                        this.visible = false
                        this.dataObj.ifEdit = false
                        this.$message.success(tip)
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            selectRole(params) {
                this.dataObj.role = params
            },
            setMonthQuota() {
                if(this.selectedRowKeys.length == 0){
                    this.$message.warning('请先选择用户')
                }else{
                    this.quotaModal = true
                }
            },
            cancelQuota() {
                this.quotaModal = false
            },
            sureQuota() {
                this.quotaModal = false
                this.axios.post('/api/externalInterface/setMonthQuota', {
                    userIdList: this.selectedRowKeys,
                    monthQuota: this.quotaData,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('设置成功')
                        this.queryBasicData()
                        this.selectedRowKeys = []
                        this.quotaData = ''
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            getDeptId(id) {
                this.dataObj.deptId = id
                this.queryBasicData()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted: function() {
            this.queryBasicData()
            this.queryTreeData()
        }
    }
</script>

<style scoped lang="less">
    .local-data{
        height: 100%;
        display: flex;
        flex-direction: column;
        .filter-criteria{
            height: 54px;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            margin-top: 1px;
            padding: 15px 24px;
        }
        .table-data{
            flex: 1;
            padding: 24px;
            .table-content{
                width: 100%;
                height: 100%;
                background: #fff;
                .basic-info{
                    height: 100%;
                    background: #fff;
                    width: 100%;
                    padding: 0 24px;
                    border-radius: 4px;
                    position: relative;
                    .operate-group{
                        height: 80px;
                        padding: 24px 24px 0 24px;
                        text-align: right;
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        z-index: 100;
                        .vertical{
                            height: 32px;
                            margin: 0 23px 0 0;
                        }
                        .add-data{
                            margin-right: 8px;
                        }
                    }
                    .download-list{
                        display: inline-block;
                        width: 160px;
                        height: 168px;
                        padding: 0;
                        background: #fff;
                        border-radius: 4px;
                        position: absolute;
                        right: 127px;
                        top: 64px;
                        box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.16);
                        z-index: 100;
                        ul{
                            li{
                                cursor: pointer;
                                height: 56px;
                                text-align: center;
                                div.first{
                                    color: rgba(80, 80, 80, 1);
                                    font-size: 14px;
                                    padding-top: 10px;
                                }
                                div.second{
                                    color: rgba(188, 188, 188, 1);
                                    font-size: 12px;
                                }
                            }
                            li:nth-child(3){
                                line-height: 36px;
                            }
                            li.checked{
                                background: rgba(242, 243, 245, 0.6);
                            }
                            .down-all{
                                padding: 0 24px;
                                .down-list-in{
                                    border-top: 1px solid rgba(229, 229, 229, 1);
                                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                                    height: 100%;
                                }
                            }
                        }
                    }
                    .tree-table{
                        display: flex;
                        height: 100%;
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        padding: 80px 24px 0 24px;
                        z-index: 10;
                        .tree{
                            width: 350px;
                            padding-right: 24px;
                            height: 100%;
                            float: left;
                            // overflow-y: auto;
                        }
                        .table-data{
                            flex: 1;
                            // float: left;
                            padding-left: 24px;
                            overflow-x: auto;
                        }
                        .pagination-table{
                            float: right;
                            padding-top: 16px;
                        }
                    }
                }
            }
        }
    }
    .drawer-public{
        height: 100%;
        position: relative;
        .drawer-content{
            padding: 0 16px 68px;
            width: 100%;
            .drawer-body-content{
                width: 100%;
                // height: 500px;
                padding: 24px;
                background: #fff;
                border-radius: 4px;
            }
        }
        .drawer-foot{
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            height: 52px;
            background: #fff;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            .btn-group{
                text-align: center;
                padding-top: 10px;
                width: 100%;
                button{
                    height: 32px;
                    font-size: 14px;
                }
                button:nth-child(2){
                    margin: 0 16px;
                }
            }
        }
    }
    .drawer-set{
        .row-list{
            margin-bottom: 13px;
            .col-left{
                padding-right: 24px;
            }
            .col-right{
                padding-left: 24px;
            }
            .title{
                color: rgba(18, 18, 18, 1);
                font-size: 12px;
                margin-bottom: 9px;
                float: left;
                span{
                    float: left;
                }
                .icon{
                    color: rgba(227, 60, 100, 1);
                    margin-left: 4px;
                }
            }
            .original-password{
                padding-top: 4px;
            }
            .select-item{
                width: 100%;
            }
            .content{
                color: rgba(153, 153, 153, 1);
            }
            .role-list{
                li{
                    float: left;
                    padding: 13px 16px;
                    margin: 8px 0 8px;
                    clear: both;
                    border: 1px solid rgba(217, 217, 217, 1);
                    border-radius: 4px;
                    cursor: pointer;
                    width: 100%;
                    box-shadow: rgba(217, 217, 217, 1) solid 1px;
                    div:nth-child(1){
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                    }
                    div:nth-child(2){
                        color: rgba(153, 153, 153, 1);
                        font-size: 12px;
                        margin-top: 8px;
                    }
                }
                li.active{
                    border-color: rgba(34, 215, 187, 1);
                    box-shadow: rgba(34, 215, 187, 1) solid 1px;
                }
            }
        }
    }
    .drawer-view{
        height: 100%;
        // overflow-y: auto;
        padding-bottom: 52px;
        position: relative;
        .basic-info{
            width: 100%;
            height: 88px;
            background: #fff;
            padding: 0 24px 0;
            .basic-info-row{
                border-top: 1px solid rgba(229, 229, 229, 1);
                padding-top: 24px;
                .title{
                    color: rgba(188, 188, 188, 1);
                    font-size: 12px;
                    margin-bottom: 6px;
                }
                .content{
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
            }
        }
        .self-info{
            margin-top: 16px;
            width: 100%;
            padding: 0 16px;
            .self-content{
                padding: 18px 24px 1px;
                background: #fff;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                .col-left{
                    padding-right: 24px;
                }
                .col-right{
                    padding-left: 24px;
                }
                .head-title{
                    color: rgba(18, 18, 18, 1);
                    font-size: 14px;
                    margin-bottom: 24px;
                }
                .self-info-row{
                    margin-bottom: 24px;
                    .title{
                        color: rgba(188, 188, 188, 1);
                        font-size: 12px;
                        margin-bottom: 9px;
                    }
                    .content{
                        color: rgba(80, 80, 80, 1);
                        font-size: 14px;
                        width: 100%;
                        .reset-password{
                            color: rgba(24, 144, 255, 1);
                            font-size: 12px;
                            margin-left: 24px;
                            cursor: pointer;
                            display: none;
                        }
                    }
                    .content:hover{
                        .reset-password{
                            display: inline-block;
                        }
                    }
                    img{
                        width: 21px;
                    }
                }
            }
            .extension-info{
                background: #fff;
                margin-top: 16px;
                margin-bottom: 16px;
                border-radius: 4px;
                padding: 18px 24px;
                .head-title{
                    color: rgba(18, 18, 18, 1);
                    font-size: 14px;
                    margin-bottom: 24px;
                }
                .col-left{
                    padding-right: 24px;
                }
                .col-right{
                    padding-left: 24px;
                }
                .head-title{
                    color: rgba(18, 18, 18, 1);
                    font-size: 14px;
                    margin-bottom: 24px;
                }
                .self-info-row{
                    margin-bottom: 24px;
                    .title{
                        color: rgba(188, 188, 188, 1);
                        font-size: 12px;
                        margin-bottom: 9px;
                    }
                    .content{
                        color: rgba(80, 80, 80, 1);
                        font-size: 14px;
                        width: 100%;
                        .reset-password{
                            color: rgba(24, 144, 255, 1);
                            font-size: 12px;
                            margin-left: 24px;
                            cursor: pointer;
                            display: none;
                        }
                    }
                    .content:hover{
                        .reset-password{
                            display: inline-block;
                        }
                    }
                    .extention-password{
                        div{
                            display: inline-block;
                        }
                        i{
                            display: none;
                            color: rgba(24, 144, 255, 1);
                            font-size: 16px;
                            margin-left: 24px;
                            cursor: pointer;
                        }
                    }
                    .extention-password:hover{
                        i{
                            display: inline-block;
                        }
                    }
                }
            }
        }
        .take-phone{
            cursor: pointer;
            .take-phone1{
                width: 14px;
                height: 14px;
                margin-left: 3px;
            }
            .take-phone2{
                display: none;
                width: 14px;
                height: 14px;
                margin-left: 3px;
            }
        }
        .take-phone:hover{
            .take-phone1{
                display: none;
            }
            .take-phone2{
                display: inline-block;
            }
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .divider3{
            margin: 0px 0 12px;
        }
        .btn-group{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                margin-right: 16px;
            }
        }
        .btn-group2{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
        .btn-group3{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(24, 144, 255, 1);
                border: 1px solid rgba(24, 144, 255, 1);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }
    .reset-modal{
        padding-top: 24px;
        padding-bottom: 48px;
        .sure-off-bind{
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 20px;
                margin-left: 24px;
            }
        }
        .tip{
            color: rgba(80, 80, 80, 1);
            padding-left: 50px;
            margin: 24px 0;
        }
    }
    .delete-modal{
        padding-top: 24px;
        padding-bottom: 48px;
        .sure-off-bind{
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 20px;
                margin-left: 24px;
            }
        }
        .tip{
            color: rgba(80, 80, 80, 1);
            padding-left: 50px;
            margin: 24px 0;
        }
    }
    .distribution-modal{
        // padding-top: 24px;
        padding-bottom: 48px;
        .sure-off-bind{
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 20px;
                margin-left: 24px;
            }
        }
        .tip{
            color: rgba(80, 80, 80, 1);
            padding-left: 50px;
            margin: 24px 0;
        }
    }
    .delete-selected-modal{
        padding-bottom: 46px;
        .des{
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
        }
        .data-num{
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            margin-top: 8px;
        }
        .reset-changed{
            text-align: right;
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            span{
                cursor: pointer;
            }
        }
    }
    .set-condition-modal{
        padding-bottom: 46px;
        .reset-changed{
            text-align: right;
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            span{
                cursor: pointer;
            }
        }
    }
    .batch-delete-modal{
        padding-bottom: 46px;
        .des{
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
        }
        .data-num{
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            margin-top: 8px;
        }
        .reset-changed{
            text-align: right;
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            span{
                cursor: pointer;
            }
        }
    }
    .edit-modal{
        padding-bottom: 48px;
        .changed-name{
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
            margin-top: 24px;
        }
        input{
            margin-top: 8px;
        }
    }
</style>